import { VueQueryPlugin } from "@tanstack/vue-query";
import { createHead } from "@unhead/vue/client";
import { setAutoFreeze } from "immer";
import { configure as configureValidation } from "vee-validate";
import { createApp } from "vue";
import { VueRecaptchaPlugin } from "vue-recaptcha";
import { DataLoaderPlugin } from "vue-router/experimental";
import App from "./App.vue";
import { posthog } from "./posthog/posthog";
import { router } from "./router";
import { sentry } from "./sentry";
import { store } from "./store";

// disable immer Auto freeze to avoid conflicts with proxies created by Vue itself
setAutoFreeze(false);

configureValidation({
  validateOnBlur: false,
  validateOnChange: false,
  validateOnInput: false,
  validateOnModelUpdate: false,
});

const app = createApp(App);

app.use(sentry);
app.use(DataLoaderPlugin, { router });
app.use(router);
app.use(store);
app.use(VueQueryPlugin);
app.use(posthog);
app.use(createHead());
app.use(VueRecaptchaPlugin, {
  v2SiteKey: "will-be-replaced",
});

app.mount("#app");
